import { useMemo } from 'react'

import { useGetLabOfficesQuery } from 'store/services/office'

export type DmeOfficeOption = {
  value: number
  label: string
}

// The DME offices to pick from, by name, with the city so same-named branches can
// be told apart: a patient's preferred DME, and where a referral packet goes.
export const useDmeOfficeOptions = (): { options: DmeOfficeOption[]; isLoading: boolean } => {
  const { data: offices = [], isLoading } = useGetLabOfficesQuery({})

  const options = useMemo<DmeOfficeOption[]>(
    () =>
      offices
        .filter((office) => office.isDmeOffice && office.officeName)
        .sort((left, right) => String(left.officeName).localeCompare(String(right.officeName)))
        .map((office) => ({
          value: Number(office.id),
          label: `${office.officeName} (${office.addressCity}, ${office.addressState})`,
        })),
    [offices],
  )

  return { options, isLoading }
}
